import { useState } from 'react'
import {
  Button,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Popper,
  MenuList,
  Grow,
  ClickAwayListener,
  Stack,
} from '@mui/material'
import * as Icons from '@mui/icons-material'
import { CropModal } from '~/crop/crop-modal/crop-modal'
import { AddPlotModal } from '../plot/add-plot/add-plot-modal'
import { TaskModal } from '~/tasks/add-task/task-modal'
import { useFeatures } from '~/common/use-features'
import { useIsSeasonReadOnly } from '~/farm/use-is-season-read-only'

export const AddMenu = () => {
  const { features } = useFeatures()
  const seasonReadOnly = useIsSeasonReadOnly()
  const [anchorEl, setAnchorEl] = useState(null)
  const [showCropModal, setShowCropModal] = useState(false)
  const [showPlotModal, setShowPlotModal] = useState(false)
  const [showTaskModal, setShowTaskModal] = useState(false)

  const open = Boolean(anchorEl)
  const anyModalOpen = showCropModal || showPlotModal || showTaskModal

  const handleAction = (setModal) => {
    setAnchorEl(null)
    setModal(true)
  }

  return (
    <Stack>
      <Button
        onClick={!anyModalOpen ? (e) => setAnchorEl(e.currentTarget) : undefined}
        startIcon={<Icons.Add fontSize="small" />}
        aria-controls={open ? 'add-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        Add
      </Button>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-end"
        transition
        sx={{ zIndex: (theme) => theme.zIndex.modal }}
      >
        {({ TransitionProps }) => (
          <Grow key={0} timeout={200} {...TransitionProps}>
            <Paper elevation={8}>
              <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                <MenuList>
                  {features['add_crops'] && (
                    <MenuItem onClick={() => handleAction(setShowCropModal)} disabled={seasonReadOnly}>
                      <ListItemIcon>
                        <Icons.Grass fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>Crop</ListItemText>
                    </MenuItem>
                  )}
                  {features['add_plots'] && (
                    <MenuItem onClick={() => handleAction(setShowPlotModal)}>
                      <ListItemIcon>
                        <Icons.GridOn fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>Plot</ListItemText>
                    </MenuItem>
                  )}
                  {features['add_tasks'] && (
                    <MenuItem onClick={() => handleAction(setShowTaskModal)} disabled={seasonReadOnly}>
                      <ListItemIcon>
                        <Icons.TodayRounded fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>Task</ListItemText>
                    </MenuItem>
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      <CropModal open={showCropModal} onClose={() => setShowCropModal(false)} />
      <AddPlotModal open={showPlotModal} onClose={() => setShowPlotModal(false)} />
      <TaskModal open={showTaskModal} onClose={() => setShowTaskModal(false)} />
    </Stack>
  )
}
